import { Route, Routes } from "react-router-dom";
import React from "react";
import NotFound from "js/pages/NotFound";
import LandlordsDashboard from "js/pages/Landlords/LandlordsDashboard";

const Landlord = () => {
  return (
    <Routes>
      <Route path="" element={<LandlordsDashboard />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Landlord;
